// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"486":"e56cfe34","961":"070109d3","989":"d90f6785"}[chunkId] + ".js";
};